module.exports = __webpack_public_path__ + "static/media/Commits.36557f9b.md";